import Shop from '@core/models/country/Shop';

export default function shopComparator(shop1: Shop, shop2: Shop): number {
    if (shop1.city && shop2.city) {
        const citySort = shop1.city.localeCompare(shop2.city);

        if (citySort !== 0) {
            return citySort;
        }
    }

    return shop1.address.localeCompare(shop2.address);
}
